// Only customer-authenticated routes can establish that a customer session expired.
export function isCustomerSessionExpired(error, token) {
  const config = error?.config;
  if (!token || config?.publicRequest || error?.response?.status !== 401
    || config?.suppressSessionRedirect
    || config?.headers?.Authorization !== `Bearer ${token}`) return false;

  let pathname;
  try {
    pathname = new URL(config.url, 'http://storefront.local').pathname;
  } catch (_) {
    return false;
  }
  return pathname.startsWith('/api/v1/customer/') || pathname === '/api/v1/auth/logout';
}
